var styleDataHash = "80543be9";
const injectCss = (() => {
  var css = `.xVW2K{border:0;height:100%;width:100%;z-index:0}.VKCY6,.xVW2K{left:0;position:absolute;top:0}.VKCY6{bottom:0;right:0;z-index:3}.mzWlY{height:0;padding-bottom:56.25%;position:relative}@supports not (contain:inline-size){@media only screen and (max-width:480px){.mzWlY{min-width:auto}}}@container (width < 480px){.mzWlY{min-width:auto}}.BtD5t,.coP7z{bottom:0;cursor:move;height:100%;position:absolute;top:0;width:100%;z-index:1}.coP7z{align-items:center;background:rgba(0,6,36,.7);display:flex;flex-direction:column;gap:12px;justify-content:center;padding:16px}.E7PIQ{color:#fff}.BtD5t~*>*,.coP7z~*>*{pointer-events:none}._-1ONM{height:0;overflow:hidden;visibility:hidden;width:0}.Ac3-P,._-1ONM{position:absolute}.Ac3-P{align-items:center;background:rgba(0,0,0,.5);color:#fff;display:flex;font-size:20px;font-weight:400;height:100%;justify-content:center;right:0;text-align:center;top:0;width:100%;z-index:1}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
});
injectCss();
var default_video_styles_default = {
  "video_player": "xVW2K",
  "videoOverlay": "VKCY6",
  "video_container": "mzWlY",
  "video_overlay": "BtD5t",
  "video_pending_overlay": "coP7z",
  "video_pending_overlay_loader": "E7PIQ",
  "hide_duration": "_-1ONM",
  "error": "Ac3-P"
};
export {
  default_video_styles_default as default,
  injectCss
};
//# sourceMappingURL=default-video-styles-scss.js.map
